import { postApi } from "../components/Utility";
import { action, makeObservable } from "mobx";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import config from "../config";

class AssignVehiclesToGeofenceStore {
  total = 0;
  loading = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      getDeviceGrpAndVehicles: action,
    });
    this.rootStore = rootStore;
  }

  async getDeviceGrpAndVehicles(data) {
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/deviceGroup/getGeofenceDeviceGroupsVehicles", {
        params: data,
      });

    return response?.data?.data;
  }

  async assignVehiclesAndGrps(data) {
    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/deviceGroup/assignGeofenceToVehicles", data);

    return response?.data?.data;
  }

  async getGeoZoneData(companyId) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=geofence&a=getgeoZone", "postData=" + base64Input);
    return response?.data?.data;
  }
}

export default AssignVehiclesToGeofenceStore;
